








































import {
  defineComponent, computed, watch, ref,
} from '@vue/composition-api';
import { Popup } from '@hb/coffee';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import store from '@/store';
import useDispatchProcess from '@/hooks/useDispatchProcess';
import { dialogHelper } from '@/shared/utils/dialogHelper';
import {
  TP_HOME_REPAY_OVERDUE_POPUP_REPAY,
  TP_HOME_REPAY_OVERDUE_POPUP_CANCEL,
  TP_HOME_REPAY_OVERDUE_POPUP,
} from '@/pages/home/tianqi';
import { local } from '@/shared/utils/storage';

export default defineComponent({
  components: {
    Popup,
  },
  emits: ['closeDailog', 'showDailog'],
  setup(_, { emit }) {
    const { repayProcessDispatch } = useDispatchProcess();
    /** 用户-弹窗记录缓存key */
    const getUserShowRecordKey = () => `RepayOverdueAlterPopup_${store.state.base?.userId || ''}`;

    /** 检查今天是否已显示过弹窗 */
    const checkTodayShown = (): boolean => !!local.get(getUserShowRecordKey());
    /** 记录今天已显示弹窗 */
    const markTodayShown = () => {
      /** 保存弹窗展示记录，缓存有效期限是当天：23:59:59 */
      local.set(getUserShowRecordKey(), 1, 0, new Date().setHours(23, 59, 59, 999));
    };
    /** 用户是否应该展示弹窗 */
    const userShouldShowPopup = ref(!checkTodayShown());
    /** 逾期天数 */
    const overdueDays = computed(
      () => Number(store.state.home.creditData?.overdueDays),
    );
    /** 当前弹窗展示状态 */
    const alterPopupVisible = computed(
      () => userShouldShowPopup.value
        && Number(overdueDays.value) > 0
        && store.state.base.hitRepaymentExperiment,
    );

    /** 关闭弹窗 */
    const closePopup = () => {
      userShouldShowPopup.value = false;

      dialogHelper.closeDialogNotify();
    };

    /** 点击"去还款" */
    const onRepayClick = () => {
      /** 进入还款流程 */
      repayProcessDispatch();
      /** 关闭弹窗 */
      closePopup();
      /** ubt埋点 */
      ubtSetupPageButton(TP_HOME_REPAY_OVERDUE_POPUP_REPAY);
    };

    /** 点击关闭 */
    const onClose = () => {
      closePopup();
      ubtSetupPageButton(TP_HOME_REPAY_OVERDUE_POPUP_CANCEL);
    };

    watch(() => alterPopupVisible.value, (visible) => {
      if (visible) {
        // 弹窗显示时记录今天已显示过
        markTodayShown();
        ubtSetupModuleExpose(TP_HOME_REPAY_OVERDUE_POPUP);
        emit('showDailog');
      } else {
        emit('closeDailog');
      }
    }, { immediate: true });

    return {
      alterPopupVisible,
      overdueDays,
      onRepayClick,
      onClose,
    };
  },
});
